/**
 * customizer-aufschlag.js
 * ========================
 * NEUE LOGIK (Multiplikator statt fix CHF pro Farbe):
 *
 * - Grundpreis pro Stück = (Gesamtpreis aus #p-calculated-sale) / quantity
 * - 1 Farbe: keine Farbmultiplikation
 * - 2 Farben: Grundpreis * 1.45
 * - 3 Farben: (Preis2)  * 1.30
 * - 4 Farben: (Preis3)  * 1.30
 * - usw. (ab 3. Farbe immer * 1.30)
 *
 * -> Farb-Aufschlag pro Stück = (Preis_mit_Farben - Grundpreis)
 *
 * LÄNGE bleibt ZUSÄTZLICH als CHF-Aufschlag pro Stück:
 * - nur wenn mehrere Farben vorhanden sind (uniqueColors > 1)
 * - ab CHAR_START Zeichen
 * - pro CHAR_STEP Zeichen: CHF_PRO_STEP_ZEICHEN
 *
 * Gesamt-Aufschlag:
 * - pro Stück: farbAufschlagProStk + laengenAufschlagProStk
 * - total: proStk * quantity
 *
 * Aufschlag-Produkt wird als separates Produkt in den Warenkorb gelegt:
 * - quantity = quantity des Hauptprodukts
 * - Variant wird anhand des pro-Stück Aufschlags gewählt (aufgerundet auf CHF)
 */

(function () {

  // ============================================================
  // KONFIGURATION — Variant-IDs hier eintragen!
  // ============================================================
  const AUFSCHLAG_VARIANTS = [
    { value: 3,  variantId: '48855149019376'  },
    { value: 4,  variantId: '48855149052144'  },
    { value: 5,  variantId: '48845528236272'  },
    { value: 6,  variantId: '48847345025264'  },
    { value: 7,  variantId: '48847345058032'  },
    { value: 8,  variantId: '48847345090800'  },
    { value: 9,  variantId: '48847345123568'  },
    { value: 10, variantId: '48845528269040' },
    { value: 11, variantId: '48847345156336' },
    { value: 12, variantId: '48847345189104' },
    { value: 13, variantId: '48847345221872' },
    { value: 14, variantId: '48847345254640' },
    { value: 15, variantId: '48845528301808' },
    { value: 16, variantId: '48847345287408' },
    { value: 17, variantId: '48847345320176' },
    { value: 18, variantId: '48847345352944' },
    { value: 19, variantId: '48847345385712' },
    { value: 20, variantId: '48845528334576' },
    { value: 21, variantId: '48847345418480' },
    { value: 22, variantId: '48847345451248' },
    { value: 23, variantId: '8847345484016' },
    { value: 24, variantId: '48847345516784' },
    { value: 25, variantId: '48845528367344' },
    { value: 30, variantId: '48845528400112' },
    { value: 40, variantId: '48845528432880' },
    { value: 50, variantId: '48845528465648' },
  ];

  // ============================================================
  // ⭐ PREIS-LOGIK SCHNELL ANPASSEN (HIER ÄNDERN)
  // ------------------------------------------------------------
  // FARBMULTIPLIKATOREN
  const MULTI_FOR_2_COLORS = 1.45; // 2 Farben: Grundpreis * 1.45
  const MULTI_EACH_EXTRA_COLOR = 1.20; // ab 3 Farben: jeweils nochmal * 1.30
  // Beispiel: 4 Farben => Grund * 1.45 * 1.30 * 1.30
  //
  // LÄNGE (zusätzlich, pro Stück)
  const CHF_PRO_STEP_ZEICHEN = 2; // CHF pro Schritt
  const CHAR_START = 20;          // erst ab 20 Zeichen
  const CHAR_STEP  = 10;          // 20–29 = 1 Schritt, 30–39 = 2 Schritte, ...
  // ============================================================

  // ----------------------------------------------------------
  // Helpers: Price / Quantity
  // ----------------------------------------------------------
  function parsePrice(text) {
    if (!text) return 0;
    const cleaned = String(text).replace(/[^\d,.\-]/g, '').trim();
    const normalized = cleaned.includes(',') && !cleaned.includes('.')
      ? cleaned.replace(',', '.')
      : cleaned;
    const val = parseFloat(normalized);
    return Number.isFinite(val) ? val : 0;
  }

  function formatCHF(amount) {
    return 'CHF ' + (Math.round(amount * 100) / 100).toFixed(2);
  }

  // kommt aus mw-bundles output (inkl. Mengenrabatt)
  function getCalculatedTotalFromPage() {
    const el = document.getElementById('p-calculated-sale');
    return el ? parsePrice(el.textContent) : 0;
  }

  function getQuantityFromPage() {
    const q =
      document.querySelector('#quantity') ||
      document.querySelector('form[action="/cart/add"] [name="quantity"]') ||
      document.querySelector('[name="quantity"]') ||
      document.querySelector('.qty-selector') ||
      document.querySelector('input[type="number"][name="quantity"]');

    const val = q ? parseInt(q.value, 10) : 1;
    return Number.isFinite(val) && val > 0 ? val : 1;
  }

  function roundUpToCHF(amount) {
    return Math.ceil(amount);
  }

  // ----------------------------------------------------------
  // Zeilendaten auslesen
  // ----------------------------------------------------------
  function getLineData() {
    const lines = document.querySelectorAll('#lines-container .line-row');
    const result = [];

    lines.forEach(function (line) {
      const textInput  = line.querySelector('.wunschtext-line-text');
      const colorInput = line.querySelector('.line-prop-color');

      const text  = textInput  ? textInput.value.trim()  : '';
      const color = colorInput ? colorInput.value.trim() : '';

      if (text.length > 0) {
        result.push({ text: text, color: color || '__default__' });
      }
    });

    return result;
  }

  // ----------------------------------------------------------
  // Multiplikator für Farben berechnen
  // ----------------------------------------------------------
  function getColorMultiplier(uniqueColors) {
    if (uniqueColors <= 1) return 1;

    let multiplier = MULTI_FOR_2_COLORS;
    const extraSteps = Math.max(0, uniqueColors - 2);
    multiplier *= Math.pow(MULTI_EACH_EXTRA_COLOR, extraSteps);

    return multiplier;
  }

  // ----------------------------------------------------------
  // Längen-Aufschlag pro Stück berechnen
  // ----------------------------------------------------------
  function getLengthSurchargePerItem(uniqueColors, maxLineChars) {
    if (uniqueColors <= 1) return 0;
    if (maxLineChars < CHAR_START) return 0;

    const charsOverStart = maxLineChars - CHAR_START;
    const steps = Math.floor(charsOverStart / CHAR_STEP) + 1;
    return steps * CHF_PRO_STEP_ZEICHEN;
  }

  // ----------------------------------------------------------
  // Aufschlag berechnen (pro Stück + total)
  // ----------------------------------------------------------
  function calculateSurcharge(lines) {
    const qty = getQuantityFromPage();

    if (!lines.length) {
      return {
        surchargePerItem: 0,
        surchargeTotal: 0,
        uniqueColors: 0,
        totalChars: 0,
        basePerItem: 0,
        coloredPerItem: 0,
        colorSurchargePerItem: 0,
        lengthSurchargePerItem: 0,
        qty: qty
      };
    }

    const colorSet     = new Set(lines.map(function (l) { return l.color; }));
    const uniqueColors = colorSet.size;

    const maxLineChars = lines.reduce(function (max, l) {
      return Math.max(max, l.text.length);
    }, 0);

    const productTotal = getCalculatedTotalFromPage();
    const basePerItem = qty > 0 ? (productTotal / qty) : 0;

    const colorMultiplier = getColorMultiplier(uniqueColors);
    const coloredPerItem = basePerItem * colorMultiplier;

    const colorSurchargePerItem = Math.max(0, coloredPerItem - basePerItem);
    const lengthSurchargePerItem = getLengthSurchargePerItem(uniqueColors, maxLineChars);
    const surchargePerItem = colorSurchargePerItem + lengthSurchargePerItem;
    const surchargeTotal = surchargePerItem * qty;

    return {
      surchargePerItem: surchargePerItem,
      surchargeTotal: surchargeTotal,
      uniqueColors: uniqueColors,
      totalChars: maxLineChars,
      basePerItem: basePerItem,
      coloredPerItem: coloredPerItem,
      colorSurchargePerItem: colorSurchargePerItem,
      lengthSurchargePerItem: lengthSurchargePerItem,
      qty: qty
    };
  }

  // ----------------------------------------------------------
  // Passende Variante finden (nächste >= CHF pro Stück, aufgerundet)
  // ----------------------------------------------------------
  function findVariant(surchargePerItem) {
    if (surchargePerItem <= 0) return null;

    const rounded = roundUpToCHF(surchargePerItem);
    const sorted = AUFSCHLAG_VARIANTS.slice().sort(function (a, b) { return a.value - b.value; });
    const match  = sorted.find(function (v) { return v.value >= rounded; });

    return match || sorted[sorted.length - 1];
  }

  // ----------------------------------------------------------
  // Info-Box anzeigen
  // ----------------------------------------------------------
  function updateUI(calc, variant) {
    let infoEl = document.getElementById('aufschlag-info');

    if (!infoEl) {
      infoEl = document.createElement('div');
      infoEl.id = 'aufschlag-info';

      const card = document.getElementById('bundle-price-card');
      if (card && card.parentNode) {
        card.parentNode.insertBefore(infoEl, card.nextSibling);
      } else {
        document.body.appendChild(infoEl);
      }
    }

    if (!variant || calc.surchargePerItem <= 0) {
      infoEl.style.display = 'none';
      return;
    }

    const productTotal = getCalculatedTotalFromPage();
    const totalInclSurcharge = productTotal + (variant.value * calc.qty);

    const detailsText = (calc.uniqueColors <= 1)
      ? `1 Farbe`
      : `${calc.uniqueColors} Farben · Multiplikator: ${getColorMultiplier(calc.uniqueColors).toFixed(2)} · längste Linie: ${calc.totalChars} Zeichen`;

    infoEl.style.display = 'block';

    infoEl.innerHTML = `
      <div class="auf-box">
        <div class="auf-head">
          <div class="auf-title"><span>🎨 Mehrfarben-Aufschlag</span></div>
          <span class="auf-badge notranslate">+ ${formatCHF(variant.value * calc.qty)}</span>
        </div>

        <div class="auf-totals">
          <div class="auf-total-row auf-grand">
            <span class="label">Gesamt inkl. Aufschlag</span>
            <span class="value notranslate">${formatCHF(totalInclSurcharge)}</span>
          </div>
        </div>

        <div class="auf-details-toggle" onclick="
          var d = this.nextElementSibling;
          var open = d.style.display !== 'none';
          d.style.display = open ? 'none' : 'block';
          this.textContent = open ? 'Details anzeigen ▾' : 'Details ausblenden ▴';
        " style="cursor:pointer; font-size:0.8em; color:#888; margin-top:8px;">
          Details anzeigen ▾
        </div>

        <div class="auf-details" style="display:none; margin-top:6px;">
          <div class="auf-rows">
            <div class="auf-row">
              <span class="label">Aufschlag pro Stück</span>
              <span class="value notranslate">${formatCHF(variant.value)}</span>
            </div>
            <div class="auf-row">
              <span class="label">Menge</span>
              <span class="value notranslate">${calc.qty}</span>
            </div>
            <div class="auf-row">
              <span class="label">Produkt gesamt (inkl. Rabatt)</span>
              <span class="value notranslate">${formatCHF(productTotal)}</span>
            </div>
          </div>
          <div class="auf-footnote">
            <strong>Details:</strong> ${detailsText}
            <br>
            <span class="notranslate">Farbe: +${formatCHF(calc.colorSurchargePerItem)}/Stk · Länge: +${formatCHF(calc.lengthSurchargePerItem)}/Stk</span>
          </div>
        </div>
      </div>
    `;
  }

  // ----------------------------------------------------------
  // Hidden Inputs:
  // - Variant-ID fürs Aufschlagprodukt
  // - sichtbare Property am Hauptprodukt
  // ----------------------------------------------------------
  function updateHiddenInput(variant, calc) {
    let el = document.getElementById('aufschlag-variant-id');
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.id   = 'aufschlag-variant-id';
      document.body.appendChild(el);
    }
    el.value = variant ? variant.variantId : '';

    let propEl = document.getElementById('aufschlag-property-input');
    if (!propEl) {
      propEl      = document.createElement('input');
      propEl.type = 'hidden';
      propEl.id   = 'aufschlag-property-input';
      propEl.name = 'properties[Mehrfarben-Aufschlag]';
      const form  = document.querySelector('form[action="/cart/add"]');
      if (form) form.appendChild(propEl);
    }

    propEl.value = (variant && calc.surchargePerItem > 0)
      ? `+CHF ${variant.value}.- / Stk (x${calc.qty})`
      : '';
  }

  // ----------------------------------------------------------
  // Recalculate
  // ----------------------------------------------------------
  function recalculate() {
    const lines = getLineData();
    const calc  = calculateSurcharge(lines);
    const variant = findVariant(calc.surchargePerItem);

    updateUI(calc, variant);
    updateHiddenInput(variant, calc);
  }

  // ----------------------------------------------------------
  // Link-Key
  // ----------------------------------------------------------
  function getLinkKey() {
    let el = document.getElementById('aufschlag-link-key');
    if (!el) {
      el = document.createElement('input');
      el.type  = 'hidden';
      el.id    = 'aufschlag-link-key';
      el.value = 'lk_' + Math.random().toString(36).slice(2, 10);
      document.body.appendChild(el);
    }
    return el.value;
  }

  function getProductTitle() {
    const el = document.querySelector('.product__title, h1.title, h1');
    return el ? el.textContent.trim() : 'Wunschtext-Produkt';
  }

  // ----------------------------------------------------------
  // Aufschlag-Produkt in den Warenkorb syncen
  // ----------------------------------------------------------
  async function syncSurchargeInCart() {

    // ✅ FIX: Frisch berechnen beim Button-Klick — nicht auf DOM-State verlassen
    const lines   = getLineData();
    const calc    = calculateSurcharge(lines);
    const variant = findVariant(calc.surchargePerItem);
    updateHiddenInput(variant, calc);

    // variantId direkt aus dem frisch berechneten variant-Objekt holen
    const variantId = variant ? variant.variantId : '';
    const linkKey   = getLinkKey();
    const mainTitle = getProductTitle();
    const qty       = calc.qty;

    console.log('[Aufschlag] syncSurchargeInCart:', { variantId, qty, surchargePerItem: calc.surchargePerItem });

    // Link-Key ins Form schreiben
    (function setLinkKeyNow() {
      const cartAddForm = document.querySelector('form[action="/cart/add"]');
      let el = document.getElementById('main-product-link-key');
      if (!el) {
        el = document.createElement('input');
        el.type = 'hidden';
        el.id   = 'main-product-link-key';
        el.name = 'properties[_link_key]';
        if (cartAddForm) cartAddForm.appendChild(el);
        else document.body.appendChild(el);
      }
      el.value = linkKey;
    })();

    // Warenkorb laden
    let cart;
    try {
      const res = await fetch('/cart.js');
      cart = await res.json();
    } catch (e) {
      console.warn('[Aufschlag] Warenkorb konnte nicht geladen werden:', e);
      return;
    }

    // alte Aufschläge entfernen (nur mit gleichem link_key)
    const updates = {};
    cart.items.forEach(function (item) {
      const itemLinkKey = item.properties && item.properties['_link_key'];
      const isSurcharge = item.properties && item.properties['_is_surcharge'] === 'true';
      if (isSurcharge && itemLinkKey === linkKey) {
        updates[item.variant_id] = 0;
      }
    });

    if (Object.keys(updates).length) {
      try {
        await fetch('/cart/update.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ updates: updates }),
        });
      } catch (e) {
        console.warn('[Aufschlag] Fehler beim Entfernen alter Aufschläge:', e);
      }
    }

    // neuen Aufschlag hinzufügen
    if (variantId) {
      try {
        const perItem = variant ? variant.value : null;

        const addRes = await fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({
            id:         variantId,
            quantity:   qty,
            properties: {
              'Aufschlag für':       mainTitle,
              '_link_key':           linkKey,
              '_is_surcharge':       'true',
              '_surcharge_per_item': perItem != null ? ('CHF ' + Number(perItem).toFixed(2)) : '',
            },
          }),
        });

        if (!addRes.ok) {
          const errText = await addRes.text();
          console.warn('[Aufschlag] Variante konnte nicht hinzugefügt werden:', variantId, errText);
        } else {
          console.log('[Aufschlag] Aufschlag erfolgreich hinzugefügt:', variantId, 'x', qty);
        }
      } catch (e) {
        console.warn('[Aufschlag] Netzwerkfehler beim Hinzufügen:', e);
      }
    } else {
      console.log('[Aufschlag] Kein Aufschlag nötig, nichts hinzugefügt.');
    }
  }

  // ----------------------------------------------------------
  // Hook Button
  // ----------------------------------------------------------
  function hookButton() {
    const btn = document.getElementById('generate-pdf-link');
    if (!btn) return;

    btn.addEventListener('click', function () {
      syncSurchargeInCart();
    }, true);
  }

  // ----------------------------------------------------------
  // Watchers
  // ----------------------------------------------------------
  function setupWatchers() {
    const container = document.getElementById('lines-container');
    if (container) {
      const observer = new MutationObserver(recalculate);
      observer.observe(container, { childList: true, subtree: true });
    }

    document.addEventListener('input', function (e) {
      if (e.target.classList && e.target.classList.contains('wunschtext-line-text')) {
        recalculate();
      }
      if (e.target && (e.target.id === 'quantity' || e.target.name === 'quantity')) {
        recalculate();
      }
    });

    document.addEventListener('change', function (e) {
      if (
        e.target.classList &&
        (e.target.classList.contains('line-prop-color') ||
         e.target.classList.contains('wunschtext-line-color-input') ||
         e.target.classList.contains('v-bundle-input'))
      ) {
        setTimeout(recalculate, 0);
      }

      if (e.target && (e.target.id === 'quantity' || e.target.name === 'quantity')) {
        recalculate();
      }
    });

    // Preis-Updates von mw-bundles
    const priceEl = document.getElementById('p-calculated-sale');
    if (priceEl) {
      const priceObserver = new MutationObserver(recalculate);
      priceObserver.observe(priceEl, { childList: true, subtree: true, characterData: true });
    }

    // Plus/Minus Buttons
    document.addEventListener('click', function (e) {
      const t = e.target;
      if (!t) return;
      if (t.id === 'plus' || t.id === 'minus') {
        setTimeout(recalculate, 0);
      }
    });
  }

  // ----------------------------------------------------------
  // Init
  // ----------------------------------------------------------
  function init() {
    setupWatchers();
    hookButton();
    recalculate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();